export default __webpack_public_path__ + "109915d191c5a99f5ea3d8b7ca3a62e8.svg";